export default __webpack_public_path__ + "static/media/mindy.d9692d02.png";